export const pageNames = {
  home: 'page.affhub.home',
  dashboard: 'page.affhub.dashboard',
  programs: 'page.affhub.programs',
  products: 'page.affhub.products',
  productsv2: 'page.affhub.productsall',
  signIn: 'page.affhub.signin',
  signUp: 'page.affhub.signup',
  setPassword: 'page.affhub.setpassword',
  joinProgram: 'page.affhub.joinprogram',
  joinProgramConfirmation: 'page.affhub.joinprogram.confirmation',
  expediaPackage: 'page.afffhub.products.expediapackage',
  bookmarklet: 'page.afffhub.products.bookmarklet',
  deeplink: 'page.afffhub.products.deeplink',
  quicklinks: 'page.affhub.products.quicklinks',
  search: 'page.affhub.products.search',
  expediaSearch: 'page.affhub.products.expediasearch',
  vrboSearch: 'page.affhub.products.vrbosearch',
  partnerPerf: 'page.affhub.analytics',
  banners: 'page.affhub.products.banners',
  commercialTerms: 'page.affhub.commercial.terms',
  aboutYourApplication: 'page.affhub.auto.reject',
  userProfile: 'page.affhub.userprofile',
  forcePZ: 'page.affhub.forcepz',
  unsubscribe: 'page.affhub.unsubscribe',
};
